import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';

@Injectable()
export class GoodreadsProvider {
    constructor(private api: ApiProvider) {}
    async getReviewsWidget(isbn: string) {
        const query = `{
            goodreadsGetItem(isbn: "${isbn}"){
                id title isbn description averageRating ratingsCount reviewsCount widget url
            }
        }`;
        return this.api.getData(query, 'isbn', isbn).then( data => data && data.widget ? data.widget: null );
    }
}

export interface GoodreadsItem {
    id: string,
    title: string,
    isbn: string,
    description: string,
    averageRating: string,
    ratingsCount: number,
    reviewsCount: number,
    widget: string,
    url: string
}


// WEBPACK FOOTER //
// ./src/providers/goodreads/goodreads.ts